import { motion } from 'framer-motion'
import lauriImg from '../../../pictures/lauri_kuva.jpg'

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
}

const stagger = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.12 } },
}

const highlights = [
  {
    icon: (
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    text: 'Robot Framework, Cypress, Playwright — testausautomaatio haltuun',
  },
  {
    icon: (
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
      </svg>
    ),
    text: 'Python & TypeScript — IoT:sta web-sovelluksiin',
  },
  {
    icon: (
      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z" />
      </svg>
    ),
    text: '4 AWS-sertifikaattia — arkkitehtuurista DevOpsiin',
  },
]

export default function About() {
  return (
    <section id="about" className="py-24 lg:py-32">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center"
        >
          {/* Photo column */}
          <motion.div variants={fadeUp} className="flex justify-center lg:justify-start">
            <div className="relative">
              <div className="absolute -inset-4 rounded-3xl bg-gradient-to-br from-blue-100 to-indigo-100 dark:from-blue-900/20 dark:to-indigo-900/20 -z-10" />
              <img
                src={lauriImg}
                alt="Lauri Perälä – MainRel Oy"
                className="w-72 h-80 lg:w-80 lg:h-96 object-cover rounded-2xl shadow-xl"
              />
            </div>
          </motion.div>

          {/* Content column */}
          <motion.div variants={stagger} className="space-y-6">
            <motion.div variants={fadeUp}>
              <span className="text-sm font-semibold text-blue-600 dark:text-blue-400 uppercase tracking-wider">
                Minä
              </span>
              <h2 className="mt-2 text-3xl sm:text-4xl font-bold text-gray-900 dark:text-white">
                Monitaitoinen IT-ammattilainen,<br />yli 20 vuoden kokemuksella
              </h2>
            </motion.div>

            <motion.p variants={fadeUp} className="text-base text-gray-600 dark:text-gray-400 leading-relaxed">
              Yli kahden vuosikymmenen kokemus on opettanut yhden asian ylitse muiden: laatu
              ei synny sattumalta. Se vaatii ihmisiä, jotka ymmärtävät sekä kehittäjien että
              testaajien maailmaa — ja osaavat toimia niiden välissä.
            </motion.p>

            <motion.p variants={fadeUp} className="text-base text-gray-600 dark:text-gray-400 leading-relaxed">
              Testausautomaatio on se alue, jossa intohimoni ja osaamiseni kohtaavat. Hyvin
              rakennettu automaatio ei pelkästään löydä vikoja nopeammin — se vapauttaa tiimin
              tekemään parempaa työtä ja tekee koko kehitysprosessista sujuvampaa.
            </motion.p>

            <motion.p variants={fadeUp} className="text-base text-gray-600 dark:text-gray-400 leading-relaxed">
              Pelkkä testaaja en ole: kehitän myös itse ohjelmistoja ja olen rakentanut
              automaatiojärjestelmiä niin pilviyhteisille IoT-laitteille, sulautetuille
              järjestelmille kuin web-sovelluksillekin. AWS on lähellä sydäntäni — useampi
              sertifikaatti kertoo siitä, mutta käytännön kokemus vielä enemmän.
            </motion.p>

            {/* Highlight bullets */}
            <motion.ul variants={fadeUp} className="pt-2 space-y-3">
              {highlights.map(({ icon, text }) => (
                <li key={text} className="flex items-start gap-3">
                  <span className="flex-shrink-0 mt-0.5 w-8 h-8 rounded-lg bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 flex items-center justify-center">
                    {icon}
                  </span>
                  <span className="text-sm text-gray-700 dark:text-gray-300 leading-snug pt-1.5">
                    {text}
                  </span>
                </li>
              ))}
            </motion.ul>
          </motion.div>
        </motion.div>
      </div>
    </section>
  )
}
